const PAGE_TITLE = "Packages";

export { PAGE_TITLE };
